



























































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'
import { MensagensDaApiEnum } from '@/types/_'
import _ from 'lodash'

@Component

export default class ComponentModalCriarEditarPontuacaoProfissional extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string

  $refs!: { formItemPontuacaoProfissional: any }

  formItemPontuacaoProfissionalRules: any = {
    valid: true,
    profissionalId: [(v: string) => !!v || 'Campo obrigatório'],
    pontuacaoId: [(v: string) => !!v || 'Campo obrigatório'],
    hospitalId: [(v: string) => !!v],
  }

  search:string = ''
  loadingPontuacaoProfissional: boolean = false
  searchProfissional: any = ''
  profissionalName: string = ''
  loadingProfissionalFilter: boolean = false

  profissionaisDebounced = _.debounce(param => this.getFinanceiroStore.getProfissionais(param), 500)

  loadCreateOrUpdateItemPontuacaoProfissional: boolean = false
  get loadingCreateOrUpdateItemPontuacaoProfissional() { return this.loadCreateOrUpdateItemPontuacaoProfissional }
  set loadingCreateOrUpdateItemPontuacaoProfissional(value: boolean) { this.loadCreateOrUpdateItemPontuacaoProfissional = value }

  get modalCriarEditarItemPontuacaoProfissional() { return this.getFinanceiroStore.modal.criarEditarItemPontuacaoProfissional }
  set modalCriarEditarItemPontuacaoProfissional(value: boolean) { this.getFinanceiroStore.setModal({ name: 'criarEditarItemPontuacaoProfissional', value }) }

  get filtroCodigoPontuacaoOuNome() { return this.getFinanceiroStore.filtroCodigoPontuacaoOuNome }
  set filtroCodigoPontuacaoOuNome(value: any) { this.getFinanceiroStore.setFiltroCodigoPontuacaoOuNome(value) }

  get equipesMedicas() {
    return this.getFinanceiroStore.equipesMedicas
  }

  get equipesMedicasParaExibicao() {
    const item = this.getFinanceiroStore.itemPontuacaoProfissional
    const equipeJaNaLista = this.equipesMedicas.some((equipe: any) => equipe.id === item.equipeProfissionalId)

    if (item.equipeProfissionalId && item.nomeEquipe && !equipeJaNaLista) {
      return [...this.equipesMedicas, { id: item.equipeProfissionalId, nome: item.nomeEquipe }]
    }

    return this.equipesMedicas
  }

  get fontesPagadorasList() {
    return this.getFinanceiroStore.fontePagadoras
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  getPontuacaoText(item) {
    return `Nome: ${item.nome} - Cód.: ${item.codigoPontuacao}`
  }

  debounce = _.debounce(() => this.getFinanceiroStore.getAllItemsSenioridade(), 300)

  async createOrUpdateItemPontuacaoProfissional() {
    this.loadingCreateOrUpdateItemPontuacaoProfissional = true
    if (this.$refs.formItemPontuacaoProfissional.validate()) {
      const request = this.mode === 'CREATE'
        ? await this.getFinanceiroStore.createPontuacaoProfissional()
        : await this.getFinanceiroStore.updatePontuacaoProfissional()

      if (request.success) {
        if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD && this.mode === 'EDIT') {
          EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
          this.modalCriarEditarItemPontuacaoProfissional = false
          this.loadingCreateOrUpdateItemPontuacaoProfissional = false
          return
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Item ${this.mode === 'CREATE' ? 'criado' : 'atualizado'} com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        this.getFinanceiroStore.clearItemPontuacaoProfissional()
        this.$emit('update-items-table', true)
        this.modalCriarEditarItemPontuacaoProfissional = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingCreateOrUpdateItemPontuacaoProfissional = false
  }

  onlyFloatUtil(value) {
    return onlyFloat(value)
  }

  changeProfissionalExecutante(value) {
    if(value){
      this.getFinanceiroStore.itemPontuacaoProfissional.profissionalId = value
    }
  }

  async onSearchPontuacao(val: any | Event){
    if(val){
      val = val.target.value
      
      if(val.length < 2){
        this.filtroCodigoPontuacaoOuNome = ''
        return
      }

      this.loadingPontuacaoProfissional = true
      this.filtroCodigoPontuacaoOuNome = val
      await this.debounce()
      this.loadingPontuacaoProfissional = false
    } else {
      this.filtroCodigoPontuacaoOuNome = ''
    }
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      this.getFinanceiroStore.setProfissionaisExecutantes([])
      this.getFinanceiroStore.itemPontuacaoProfissional.profissionalId = ''
      return
    }

    if(this.profissionalName === val){
      return
    } 
    
    this.loadingProfissionalFilter = true
    if(this.profissionaisDebounced) await this.profissionaisDebounced(val)
    this.loadingProfissionalFilter = false
  }

  @Watch('modalCriarEditarItemPontuacaoProfissional')
  async onChangeModalCriarEditarItemPontuacaoProfissional(value: boolean) {
    if (!value) {
      this.getFinanceiroStore.clearItemPontuacaoProfissional()
      this.getFinanceiroStore.clearOriginalItemPontuacaoProfissional()
      this.getFinanceiroStore.setProfissionaisExecutantes([])
      this.searchProfissional = ''
      this.profissionalName = ''
      this.$refs.formItemPontuacaoProfissional.resetValidation()
    } else {
      const item = this.getFinanceiroStore.itemPontuacaoProfissional;

      if (item && item.profissionalId) {
        const profissionalEditando = {
          userId: item.profissionalId,
          nome: item.nomeProfissional || 'Profissional Selecionado' 
        };

        this.getFinanceiroStore.setProfissionaisExecutantes([profissionalEditando]);

        this.profissionalName = profissionalEditando.nome;
        this.searchProfissional = profissionalEditando.nome;
      }

      if (this.mode === 'EDIT' && item.codigoPontuacao) {
        this.loadingPontuacaoProfissional = true
        this.filtroCodigoPontuacaoOuNome = item.codigoPontuacao
        await this.debounce()
        this.loadingPontuacaoProfissional = false
      }
    }
  }
}
